"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RESPONSIVE_DIALOG_LOADING = void 0;
const RESPONSIVE_DIALOG_LOADING = exports.RESPONSIVE_DIALOG_LOADING = 'responsive-dialog-loading';
